import { ColDef, } from 'ag-grid-community';

export const FinanceDefaultCol: ColDef = {
  suppressHeaderFilterButton: true,
  suppressHeaderContextMenu: true,
  suppressHeaderMenuButton: true,
  sortable: false,
  filter: false,
  mainMenuItems: []
}
